import axios from 'axios';
import { API_BASE } from './config';

/**
 * Fetch indexer performance metrics
 * @returns Performance metrics for indexer endpoints
 */
export const fetchIndexerPerformanceMetrics = async () => {
  try {
    // Add timeout to prevent hanging requests
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

    const response = await axios.get(`${API_BASE}/indexer/monitoring/performance`, {
      signal: controller.signal
    });

    clearTimeout(timeoutId);
    return response.data;
  } catch (error: any) {
    if (error?.name === 'AbortError') {
      console.error('Indexer performance metrics request timed out');
      // Return a default response instead of throwing
      return {
        status: 'error',
        message: 'Request timed out',
        totalRequests: 0,
        successfulRequests: 0,
        failedRequests: 0,
        averageResponseTime: 0,
        successRate: 0,
        endpoints: {}
      };
    }
    throw error;
  }
};

/**
 * Fetch endpoint metrics
 * @param endpoint Optional endpoint path to filter by
 * @param method Optional HTTP method to filter by
 * @returns Metrics for specific endpoints
 */
export const fetchEndpointMetrics = async (endpoint?: string, method?: string) => {
  try {
    // Add timeout to prevent hanging requests
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

    const params: Record<string, string> = {};
    if (endpoint) params.endpoint = endpoint;
    if (method) params.method = method;

    const response = await axios.get(`${API_BASE}/indexer/monitoring/endpoints`, {
      params,
      signal: controller.signal
    });

    clearTimeout(timeoutId);
    return response.data;
  } catch (error: any) {
    if (error?.name === 'AbortError') {
      console.error('Endpoint metrics request timed out');
      // Return a default response instead of throwing
      return {
        status: 'error',
        message: 'Request timed out',
        endpoints: []
      };
    }
    throw error;
  }
};
